module.exports = __webpack_public_path__ + "img/08_full.d6106987.jpg";